export enum LeadSourceEnum {
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  TIKTOK = 'TIKTOK',
  GOOGLE = 'GOOGLE',
  SITE = 'SITE',
  INDICACAO = 'INDICACAO',
  OUTRO = 'OUTRO',
}

export const LEAD_SOURCE_VALUES: LeadSourceEnum[] = [
  LeadSourceEnum.INSTAGRAM,
  LeadSourceEnum.FACEBOOK,
  LeadSourceEnum.TIKTOK,
  LeadSourceEnum.GOOGLE,
  LeadSourceEnum.SITE,
  LeadSourceEnum.INDICACAO,
  LeadSourceEnum.OUTRO,
];
